import styled from "styled-components";

const AboutStyles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-bottom: 120px;
`;

const AboutImage = styled.img`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  object-fit: cover;
`;

const AboutType = styled.div`
  padding-bottom: 75px;
  text-align: center;

  @media (max-width: 641px) {
    margin: 0 30px;
    word-wrap: anywhere;
  }

  @media (min-width: 640px) {
    > div {
      max-width: 660px;
    }
  }

  * {
    color: #000000;
  }

  > h3 {
    line-height: 1.55;
    font-size: 40px;
  }

  > div {
    font-size: 18px;
    line-height: 1.35;
  }

  .about-text {
    p {
      margin: 0 0 1em;
    }

    p:last-child {
      margin-bottom: 0;
    }

    p:empty {
      display: none;
    }

    ul,
    ol {
      display: inline-block;
      text-align: left;
    }

    a {
      color: #000000;
    }
  }
`;

const ListStyles = styled.div`
  display: flex;
  margin-top: 90px;
  font-size: 14px;

  > div {
    display: flex;
    flex-direction: column;
    row-gap: 15px;
    flex: 1;

    li,
    a {
      line-height: 1.6;
    }

    > div {
      a {
        cursor: pointer;
        color: #222222;
      }

      ul {
        margin: 0;
      }
    }
  }

  @media (min-width: 641px) {
    column-gap: 40px;
  }

  @media (max-width: 640px) {
    flex-direction: column;
    row-gap: 15px;
  }
`;

export { AboutImage, AboutStyles, AboutType, ListStyles };
